// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2Cfrl","signatureBlock":"Footer_signatureBlock__15yR5","signature":"Footer_signature__m6Q8s"};